import { create } from 'zustand';
import type {
  MacroAnalysis,
  MicroAnalysis,
  StationAlert,
  RoutingDimension,
} from '@shipping/core';

interface AnalysisState {
  macro: MacroAnalysis | null;
  micro: MicroAnalysis | null;
  stationAlerts: StationAlert[];
  selectedDimension: RoutingDimension;

  setMacro: (data: MacroAnalysis) => void;
  setMicro: (data: MicroAnalysis) => void;
  setStationAlerts: (alerts: StationAlert[]) => void;
  setSelectedDimension: (dimension: RoutingDimension) => void;
  reset: () => void;
}

export const useAnalysisStore = create<AnalysisState>((set) => ({
  macro: null,
  micro: null,
  stationAlerts: [],
  selectedDimension: 'composite',

  setMacro: (data) => set({ macro: data }),
  setMicro: (data) => set({ micro: data }),
  setStationAlerts: (alerts) => set({ stationAlerts: alerts }),
  setSelectedDimension: (dimension) => set({ selectedDimension: dimension }),
  reset: () =>
    set({
      macro: null,
      micro: null,
      stationAlerts: [],
      selectedDimension: 'composite',
    }),
}));
